import api from './axios';

export async function fetchPublicPosts(params = {}) {
  const { data } = await api.get('/public/posts', { params });
  return data;
}

export async function fetchPublicPostById(id) {
  const { data } = await api.get(`/public/posts/${id}`);
  return data.post;
}

export async function fetchPublicAuthors() {
  const { data } = await api.get('/public/authors');
  return data;
}

export async function fetchPublicAuthor(id) {
  const { data } = await api.get(`/public/authors/${id}`);
  return data.author;
}

export async function fetchPublicEvents(params = {}) {
  const { data } = await api.get('/public/events', { params });
  return data.events || [];
}
